// Copyright (c) Jupyter Development Team.
// Copyright (c) Microsoft Corporation.
// Distributed under the terms of the Modified BSD License.
import { css } from '@microsoft/fast-element';
/**
 * Styles for Data Grid
 * @public
 */
export const dataGridStyles = (context, definition) => css `
  :host {
    display: flex;
    position: relative;
    flex-direction: column;
  }
`;
